import React, { useState } from "react";
import styled from "styled-components";

const Container = styled.div`
  height: 70px;
  width: 100%;
  background-color: ${({ navbar }) => (navbar ? "crimson" : " transparent")};
  position: fixed;
  top: 0;
  z-index: 999;
  display: flex;
  flex-direction: column;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 10px 20px;
  justify-content: space-between;
`;
const Left = styled.div`
  display: flex;
  width: 70%;
  align-items: center;
  justify-content: space-between;
`;
const Logo = styled.a`
  font-weight: bold;
  text-decoration: underline crimson;
  cursor: pointer;
  font-size: 30px;
  color: ${({ navbar }) => (navbar ? "white" : " black")};
  &:hover {
    color: ${({ navbar }) => (navbar ? "black" : " crimson")};
  }
`;
const Menu = styled.ul`
  display: flex;
  list-style: none;
  @media only screen and (max-width: 480px) {
    display: none;
  }
`;
const MenuItem = styled.li`
  margin-right: 30px;
  color: ${({ navbar }) => (navbar ? "white" : " gray")};
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
`;

const JoinButton = styled.button`
  color: white;
  font-weight: bold;
  border-radius: 10px;
  border: 2px solid white;
  background-color: crimson;
  text-transform: uppercase;
  cursor: pointer;
  padding: 10px 15px;
  letter-spacing: 2px;
`;

const Heart = styled.span`
  color: ${({ navbar }) => (navbar ? "white" : " crimson")};
`;

const LinkPage = styled.a`
  color: ${({ navbar }) => (navbar ? "white" : " gray")};
  text-decoration: none;
  &:hover {
    color: ${({ navbar }) => (navbar ? "black" : " crimson")};
  }
`;

const LinkButton = styled.a`
  color: white;
  text-decoration: none;
`;

const Navbar = () => {
  const [navbar, setNavbar] = useState(false);

  const changeBackgroundNavbar = () => {
    if (window.scrollY >= 80) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  window.addEventListener("scroll", changeBackgroundNavbar);

  return (
    <Container navbar={navbar}>
      <Wrapper>
        <Left>
          <Logo href="#" navbar={navbar}>
            <Heart navbar={navbar}>&#9825;</Heart>Mercy
            <Heart navbar={navbar}>&#9825;</Heart>
          </Logo>
          <Menu>
            <MenuItem navbar={navbar}>
              <LinkPage href="#" navbar={navbar}>
                Home
              </LinkPage>
            </MenuItem>
            <MenuItem>
              <LinkPage href="#Features" navbar={navbar}>
                Features
              </LinkPage>
            </MenuItem>
            <MenuItem>
              <LinkPage href="#Offres" navbar={navbar}>
                Services
              </LinkPage>
            </MenuItem>
            <MenuItem>
              <LinkPage href="#Pricing" navbar={navbar}>
                Pricing
              </LinkPage>
            </MenuItem>
            <MenuItem>
              <LinkPage href="#Contact" navbar={navbar}>
                Contact
              </LinkPage>
            </MenuItem>
          </Menu>
        </Left>
        <JoinButton>
          <LinkButton href="https://tn.linkedin.com/in/mahmoud-ayed-111329207">
            Join Today
          </LinkButton>
        </JoinButton>
      </Wrapper>
    </Container>
  );
};

export default Navbar;
